// extracted by mini-css-extract-plugin
export default {"tile_container":"laa","tile_img_container":"maa","not_recommended_label":"naa","modal_root":"oaa","content":"paa","warning":"qaa","x_mark":"raa","tile_img":"saa","tile_type":"taa","tile_product_title":"uaa","tile_product_price":"vaa","tile_descr_line":"waa","tile_descr_icon":"xaa","info_icon":"yaa","tile_descr_text":"zaa","tile_btns_container":"Aaa","info_container":"Baa","info_text":"Caa"};
    if(module.hot) {
      // 1721922369045
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  